import Box from "./Box";
import Footer from "./Footer";
import Head from "next/head";
import Header from "./Header";
import PropTypes from "prop-types";
import React from "react";

function TakebackLayout({ embedMode, children, title, headings, size }) {
  return (
    <Box bg="offForeground">
      <Head>
        <title>{title}</title>
      </Head>
      <Box maxWidth={1920} mx="auto" bg="background" position="relative">
        {!embedMode && <Header {...headings} size={size} />}
        <Box px="4vw" py={[23, null, null, 50]}>
          {children}
        </Box>
        {!embedMode && <Footer />}
      </Box>
    </Box>
  );
}

TakebackLayout.propTypes = {
  embedMode: PropTypes.bool.isRequired,
  handleDataLoaded: PropTypes.func,
};

export default TakebackLayout;
